import {commonService} from "./common.services";

export  const playlistService = {
    getAllPlaylist,
    createPlaylist,
    getPlaylistDetails,
    getPlaylistVignets,
    addToPlaylist,
    removeFromPlaylist,
    savePlaylistName,
    sortPlaylist,
    updatePlaylist,
    deletePlaylist,
    duplicatePlaylist,
    purgeImage
}

function getAllPlaylist(data) {

    return commonService.sendHttpRequest('rbuilder/listplaylist', data, "POST");
}

function createPlaylist(data) {
    console.log("createPlaylist");
    return commonService.sendHttpRequest('rbuilder/createplaylist', data, "POST");
}

function getPlaylistDetails(data) {

    return commonService.sendHttpRequest('rbuilder/playlistdetails', data, "GET");
}

function getPlaylistVignets(data)
{
    return commonService.sendHttpRequest('rbuilder/playlistvignets', data, "GET");
}

function addToPlaylist(data) {
    console.log("addToPlaylist");
    return commonService.sendHttpRequest('rbuilder/addtoplaylist', data, "POST");
}

function removeFromPlaylist(data) {
    console.log("removeFromPlaylist");
    return commonService.sendHttpRequest('rbuilder/removefromplaylist', data, "POST");
}

function savePlaylistName(data) {
    console.log("savePlaylistName");
    return commonService.sendHttpRequest('rbuilder/saveplaylistname', data, "POST");
}

function sortPlaylist(data) {
    console.log("sortPlaylist");
    return commonService.sendHttpRequest('rbuilder/sortplaylist', data, "POST");
}

function updatePlaylist(data) {
   // return commonService.sendHttpRequest('rbuilder/updateVignetName', data, "POST");
}

function deletePlaylist(data) {
    return commonService.sendHttpRequest('rbuilder/deleteplaylist', data, "POST");
}

function duplicatePlaylist(data) {
    return commonService.sendHttpRequest('rbuilder/duplicateplaylist', data, "POST");
}

function purgeImage(data) {
    return commonService.sendHttpRequest('rbuilder/purgeimage', data, "GET");
}


// WEBPACK FOOTER //
// ./src/services/playlist.services.js